import React, { Dispatch, SetStateAction } from 'react';

import { ardotAttributeDictionary } from '@atom/components/common/requests/customTenantUtilities';
import {
  ARDOTAttribute,
  AssetRequestCreateInput,
} from '@atom/types/assetRequest';
import { InventoryAssetDetailType } from '@atom/types/inventory';

import { View } from '../CreateRequestModal';

import ApprovalSection from './ApprovalSection';
import AttributesSection from './AttributesSection';
import TransferSection from './TransferSection';

import './ardotCreate.css';

interface Props {
  createInputs: AssetRequestCreateInput;
  updateCreateInput: (
    value: any,
    property: keyof AssetRequestCreateInput,
  ) => void;
  asset: InventoryAssetDetailType;
  setView: Dispatch<SetStateAction<View>>;
  transferToggle: boolean;
  setTransferToggle: Dispatch<SetStateAction<boolean>>;
}

const ARDOT118TransferCreate = ({
  asset,
  createInputs,
  updateCreateInput,
  setView,
  transferToggle,
  setTransferToggle,
}: Props) => {
  const attributeDictionary = ardotAttributeDictionary(asset);

  return (
    <>
      <div>
        <div styleName="row-title">{ARDOTAttribute.TAG_NUMBER}</div>
        <div>
          {attributeDictionary[ARDOTAttribute.TAG_NUMBER]?.value || '-'}
        </div>
      </div>
      <div styleName="view-row">
        <div styleName="row-title">{ARDOTAttribute.DESCRIPTION}</div>
        <div>
          {attributeDictionary[ARDOTAttribute.DESCRIPTION]?.value || '-'}
        </div>
      </div>
      <AttributesSection
        asset={asset}
        createInputs={createInputs}
        updateCreateInput={updateCreateInput}
      />
      <TransferSection
        createInputs={createInputs}
        updateCreateInput={updateCreateInput}
        setView={setView}
        transferToggle={transferToggle}
        setTransferToggle={setTransferToggle}
      />
      <ApprovalSection
        asset={asset}
        createInputs={createInputs}
        updateCreateInput={updateCreateInput}
      />
    </>
  );
};

export default ARDOT118TransferCreate;
